import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  loading: false,
  dailyReport: [],
  openDailyReports: {
    info: {},
    data: [],
  },
  isReportGenerated: false,
}

export default factoryReducer(initialState, actions)
